import React, { useState } from "react";

import Index from "@/pages/Index";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import { Routes, Route, useNavigate } from "react-router-dom";
import CreateEvent from "@/pages/CreateEvent";
import EventDashboard from "@/pages/EventDashboard";
import Profile from "@/pages/Profile";
import Billing from "@/pages/Billing";
import Events from "@/pages/Events";
import EventRegistration from "@/pages/EventRegistration";
import NotFound from "@/pages/NotFound";
import AllEvents from "@/pages/AllEvents";
import Dashboard from "@/pages/Dashboard";
import EmailOtpVerification from "@/pages/auth/EmailOtpVerification";
import ResetPassword from "@/pages/auth/ResetPassword";
import ProtectedRoute from "@/components/ProtectedRoute";
import Pricing from "@/pages/Pricing";
import DigitalEvent from "@/pages/DigitalEvent";
import {
  getCurrentClientData,
  refreshTokenApi,
  saveUserTokenSession,
} from "@/services/authServices";
import { useAutoTokenRefresh } from "@/hooks/refresh-token-hooks";
import { useToast } from "@/hooks/use-toast";
import ManageAttendees from "@/pages/ManageAttendees";
import ChangePassword from "@/pages/auth/ChangePassword";
import TermsAndConditions from "./term";
import AdminRoutes from "@/admin/AdminRoutes";
const AppRoutes = () => {
  const navigate = useNavigate();
  const loggedInUser = getCurrentClientData();
  const tokenDetails = JSON.parse(localStorage.getItem("streamEventAuthToken"));
  const { toast } = useToast();
  const [refreshToken, setRefreshToken] = useState(() => {
    const tokenData = JSON.parse(
      localStorage.getItem("streamEventAuthToken") || "{}"
    );
    return tokenData?.streamEventRefToken || "";
  });

  const refreshAccessToken = async () => {
    try {
      const response: any = await refreshTokenApi({
        refreshToken,
        email: loggedInUser?.clientData?.email,
      });
      if (response.statusCode === 200 || response.statusCode === 201) {
        await saveUserTokenSession(response);
      } else {
        toast({
          title: "Session expired",
          description: "Please sign in again.",
          variant: "destructive",
        });
        localStorage.clear();
        sessionStorage.clear();
        navigate("/signin");
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      localStorage.clear();
      sessionStorage.clear();
      navigate("/signin");
      toast({
        title: "Session expired",
        description: "Please sign in again.",
        variant: "destructive",
      });
    }
  };

  useAutoTokenRefresh({
    accessToken: loggedInUser.token,
    refreshToken,
    tokenExpiry: loggedInUser?.clientData?.exp || undefined,
    onRefresh: refreshAccessToken,
  });

  return (
    <Routes>
      {/* Admin Portal Routes */}
      <Route path="/admin/*" element={<AdminRoutes />} />
      
      {/* Main Application Routes */}
      <Route path="/" element={<Index />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/verify-account" element={<EmailOtpVerification />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route path="/reset-password" element={<ChangePassword />} />

      <Route path="/all-events" element={<AllEvents />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create" element={<CreateEvent />} />
        <Route path="/dashboard/:eventId" element={<EventDashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/events" element={<Events />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/terms" element={<TermsAndConditions />} />

        <Route path="/event/:eventId/attendees" element={<ManageAttendees />} />
        <Route path="/digital-event/:eventId" element={<DigitalEvent />} />
      </Route>

      {/* Public routes */}
      <Route path="/event/:eventId/register" element={<EventRegistration />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
